import { FC, ReactNode } from 'react';
import styles from './NestedMenu.module.scss';

type ComponentWrapperProps = {
  children: ReactNode;
};

/**
 * Wrapper used for wrapping certain components in the NestedMenu
 */
const ComponentWrapper: FC<ComponentWrapperProps> = ({ children }) => (
  <div className={styles.componentWrapper}>
    {children}
  </div>
);
export default ComponentWrapper;
